import { useMe } from '@capsicum/socios-core';

// TODO Should be moved to backend
// Last date list of EEA countries checked - 25.03.2024
const EEA_COUNTRIES = [
	{
		iso2: 'AT',
		iso3: 'AUT',
		name: 'Austria'
	},
	{
		iso2: 'BE',
		iso3: 'BEL',
		name: 'Belgium'
	},
	{
		iso2: 'BG',
		iso3: 'BGR',
		name: 'Bulgaria'
	},
	{
		iso2: 'HR',
		iso3: 'CRV',
		name: 'Croatia'
	},
	{
		iso2: 'CY',
		iso3: 'CYP',
		name: 'Cyprus'
	},
	{
		iso2: 'CZ',
		iso3: 'CZE',
		name: 'Czechia'
	},
	{
		iso2: 'DK',
		iso3: 'DNK',
		name: 'Denmark'
	},
	{
		iso2: 'EE',
		iso3: 'EST',
		name: 'Estonia'
	},
	{
		iso2: 'FI',
		iso3: 'FIN',
		name: 'Finland'
	},
	{
		iso2: 'FR',
		iso3: 'FRA',
		name: 'France'
	},
	{
		iso2: 'DE',
		iso3: 'DEU',
		name: 'Germany'
	},
	{
		iso2: 'GR',
		iso3: 'GRC',
		name: 'Greece'
	},
	{
		iso2: 'HU',
		iso3: 'HUN',
		name: 'Hungary'
	},
	{
		iso2: 'IE',
		iso3: 'IRL',
		name: 'Ireland'
	},
	{
		iso2: 'IT',
		iso3: 'ITA',
		name: 'Italy'
	},
	{
		iso2: 'LV',
		iso3: 'LVA',
		name: 'Latvia'
	},
	{
		iso2: 'LT',
		iso3: 'LTU',
		name: 'Lithuania'
	},
	{
		iso2: 'LU',
		iso3: 'LUX',
		name: 'Luxembourg'
	},
	{
		iso2: 'MT',
		iso3: 'MLT',
		name: 'Malta'
	},
	{
		iso2: 'NL',
		iso3: 'NLD',
		name: 'Netherlands'
	},
	{
		iso2: 'PL',
		iso3: 'POL',
		name: 'Poland'
	},
	{
		iso2: 'PT',
		iso3: 'PRT',
		name: 'Portugal'
	},
	{
		iso2: 'RO',
		iso3: 'ROU',
		name: 'Romania'
	},
	{
		iso2: 'SK',
		iso3: 'SVK',
		name: 'Slovakia'
	},
	{
		iso2: 'SI',
		iso3: 'SVN',
		name: 'Slovenia'
	},
	{
		iso2: 'ES',
		iso3: 'ESP',
		name: 'Spain'
	},
	{
		iso2: 'SE',
		iso3: 'SWE',
		name: 'Sweden'
	}
];

export const useEeaUser = () => {
	const { isMeLoading, me } = useMe();

	return {
		isEeaUser: me?.vatCountry && EEA_COUNTRIES.map(x => x.iso2).includes(me?.vatCountry),
		isLoading: isMeLoading
	};
};
